export const CLIENT_FACING_SHIFT_TYPE_IDS = [1, 2];
